<style>
  .fist-time-chat {
    float: left;
  }

  .fist-time-formprompt .position-fixed {
    left: 0;
    width: calc(100% - 19%);
    padding-left: 0;
  }

  .fist-time-formprompt .bg-card-light {
    background: none;
  }
</style>
<div *ngIf="isLoading">
</div>
<main>

  <div *ngIf="!isUserHaveAccess">

    <div class="row m-t-30">
      <div class="col-xs-12 text-center">
        <h1 class="font-h4 weight-400 m-b-15"> {{ChatbotAccessText}} </h1>

      </div>
    </div>
  </div>

  <div *ngIf="isUserHaveAccess">
    <div class="row">
      <div *ngIf="ShowChatHistory && ConversationHistoryCount >= 0"
        class="col-lg-3 col-md-3 col-sm-12 col-xs-12 position-sticky p-t-0 no-scroll-x bg-gray-50 chat-scroll">
        <div *ngIf="!IsFirstTime">
          <app-chat-sessions *ngIf="ShowChatHistory && ConversationHistoryCount >= 0" [chatSessionList]="chatSessionList"
            [vectorDbDatasets]="vectorDbDatasets" [isResponseScroll]="isResponseScroll" [txtChat]="txtChat"
            [IsLikeSelected]="IsLikeSelected" [isLoadingsession]="isLoadingsession" [datasetLoadingStates]="datasetLoadingStates" [IsResponseStreaming]="IsResponseStreaming"
            [ChatQueriesList]="ChatQueriesList" [currentSessionId]="currentSessionId"
            [loaderShow]="loaderShow" [isProcessing]="isProcessing" [hasActiveStreamingSubscription]="hasActiveStreamingSubscription"
            [moduleThreadsCounts]="moduleThreadsCounts" [selectedTabInput]="selectedTab"
            [datasetApiTriggered]="datasetApiTriggered" [privilegesData]="privilegesDataForAgents"
            (closeHistory)="DisableChatHistory()" (universalLoading)="universalLoader($event)"
            (resetChatState)="resetChatState()" (showPopupMessage)="showPopupMessage($event)"
            (resizeDropdownWidth)="resizeDropdownWidth()" (getChatHistory)="GetChatHistory($event)"
            (getChatSessionsInfo)="GetChatSessionsInfo($event)" (ClickNewChat)="ClickNewChat($event)"
            (loadMoreSessions)="loadMoreChatSessions($event)" (tabSelected)="onTabSelected($event)" (updateFilter)="updateFilter($event)" 
            (chatSessionListChange)="updateChatSessionList($event)" (showDeleteSuccessMessage)="showDeleteSuccessMessage()" 
            (showEditSuccessMessage)="showEditSuccessMessage()" (showShareSuccessMessage)="showShareSuccessMessage()"
            (stopStreamingFunc)="stopStreaming()" (stopSpeakingFunc)="stopSpeaking()"
            (scrollToBottomAfterSession)="onScrollToBottomAfterSession()" 
            (datasetToggled)="onDatasetToggled($event)"
            (agentSelectedFromSidebar)="handleAgentSelectionFromSidebar($event)">
          </app-chat-sessions>

        </div>
      </div>
      <div class="p-r-0 p-l-0 chat-right-box"
        [ngClass]="{
          'nosources': !isSourcePanelVisible && !isFilePreviewVisible,
          'showsources': isSourcePanelVisible || isFilePreviewVisible,
          'fullwidth-response': !ShowChatHistory && !isSourcePanelVisible && !isFilePreviewVisible
        }">
        <!-- Session Loading -->
        <div *ngIf="isLoading" class="session-loading-overlay">
          <div class="session-loading-container">
            <app-loading></app-loading>
            <span class="session-loading-text">{{'LOADING_SESSION_TEXT' | translate}}</span>
          </div>
        </div>
        
        <div class="floating-chat-menu" *ngIf="!ShowChatHistory && !showHelp && firstTimeLoginDetails.wizard_completion_status === 'completed'">
          <button alt="Expand" [attr.data-tooltip]="'CHAT_HISTORY_PANEL_EXPAND_MENU_TOOL_TIP' | translate"
            [attr.aria-label]="'CHAT_HISTORY_PANEL_EXPAND_MENU_TOOL_TIP' | translate" (click)="DisplayChatHistory()" class="chat-menu-item t-right t-no-arrow" id='chat-history-button'
            *ngIf="isChatSessionListValid()">
            <img src="../../../assets/images/newchat/icon-toggle-button.svg" alt="Expand" >
          </button>
          <button [attr.data-tooltip]=" 'CHAT_HISTORY_PANEL_NEW_TOPIC_BUTTON' | translate"
            [attr.aria-label]=" 'CHAT_HISTORY_PANEL_NEW_TOPIC_BUTTON' | translate" class="chat-menu-item t-right t-no-arrow" (click)="ClickNewChat(true)" id='new_topic_button'>
            <img src="../../../assets/images/newchat/icon-newtopic.svg" alt="New Topic" >
          </button>
        </div>
        <div *ngIf="!IsFirstTime" class="chat-expandable-area-new" id='chat-expandable-area'>
          <div *ngIf="DeleteSuccessMessage || EditSuccessMessage || ShareSuccessMessage" class="toast success" id='toast_message'>
            <div class="toast-icon">
              <img src="../../../assets/images/newchat/correct.svg" width="18" alt="Success">
              <span class="toast-title">{{'SUCCESS_MESSAGE_TITLE_TEXT' | translate}}</span>
              <span *ngIf="DeleteSuccessMessage" id='delete_chat_success_message'>{{'DELETE_POPUP_TOASTER_MESSAGE' | translate}}</span>
              <span *ngIf="EditSuccessMessage" id='edit_chat_success_message'>{{'RENAME_POPUP_TOASTER_MESSAGE' | translate}}</span>
              <span *ngIf="ShareSuccessMessage" id='share_chat_success_message'>{{'SHARE_POPUP_TOASTER_MESSAGE' | translate}}</span>
            </div>
            <a title="{{'CLOSE_TITLE_TEXT' | translate}}" href="javascript:void(0)" (click)="CloseSuccessMessage()"
              id='success_message_close_button'>
              <i class="icon-close1"></i>
            </a>
          </div>

          <div *ngIf="IsCustomErrorMessageVisible" class="toast error" id='error_toast_message'>
            <div class="toast-icon">
              <img src="../../../assets/images/newchat/exclamation.svg" width="18" alt="Error">
              <span class="toast-title">{{'ERROR_TITLE_TEXT' | translate}}</span>
              <span id='custom_error_message'>{{CustomErrorMessageText}}</span>
            </div>
            <a title="{{'CLOSE_TITLE_TEXT' | translate}}" href="javascript:void(0)" (click)="CloseSuccessMessage()"
              id='error_message_close_button'>
              <i class="icon-close1"></i>
            </a>
          </div>
          <!-- ✅ MODIFIED: Conditional Greeting (only show if NOT agent mode) -->
          <div class="greetings-text" *ngIf="IsNewChat && !isInAgentMode && !loaderShow" [ngClass]="{'shift-up': isMyUploadedFiles}">
            <h1>{{ getGreetingMessage() }}</h1>
            <h2>{{'GREETING_TEXT.GREY_MESSAGE' | translate}}</h2>
          </div>

          <!-- Loader for NEW CHAT (when IsNewChat is true) -->
          <div *ngIf="showEngagingLoader && IsNewChat && !isInAgentMode && loaderShow" style="padding: 20px;">
            <app-engaging-loader [showStreamingDots]="!showEngagingLoader && loaderShow" [module]="selectedVectorDbDataset?.name?.toLowerCase() || 'regulations'"></app-engaging-loader>
          </div>

          <!-- ✅ NEW: Agent Chat Container (includes landing, chat, and prompt) -->
          <div class="agent-container-wrapper" *ngIf="isInAgentMode" [ngClass]="{'sidebar-open': ShowChatHistory, 'sidebar-closed': !ShowChatHistory}">
            <app-agent-chat-container
              [loaderShow]="loaderShow"
              [userFName]="userFName"
              [chatbotComponentRef]="this"
              [isSidebarOpen]="ShowChatHistory">
            </app-agent-chat-container>
          </div>
          <div>
          <div class="response-history-area-new p-t-8" *ngIf="!IsNewChat && !isInAgentMode">
            <div class="scrollDiv" *ngFor="let chatdata of ChatQueriesList;  let chatCount = index">
              <!-- File Pills Above Question Card -->
              <div class="message-file-pills" *ngIf="isFileUploadEnabled && chatdata.attachedFiles && chatdata.attachedFiles.length > 0 && (chatCount !== (ChatQueriesList.length - 1))">
                <div class="message-file-pill" *ngFor="let file of chatdata.attachedFiles" 
                     (click)="previewFile(file)"
                     (keydown.enter)="previewFile(file)"
                     tabindex="0"
                     role="button"
                     [attr.aria-label]="'Preview file ' + file.name"
                     [title]="file.name + ' - ' + formatFileSize(file.size)">
                  <div class="message-file-pill-icon">
                    <img src="./assets/icons/pdf-icon.svg" alt="PDF" *ngIf="file.type === 'application/pdf'" />
                    <img src="./assets/icons/word-icon.svg" alt="Word" *ngIf="file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" />
                    <img src="./assets/icons/text.svg" alt="Text" *ngIf="file.type === 'text/plain'" />
                  </div>
                  <span class="message-file-pill-name">{{ file.name }}</span>
                </div>
              </div>
              <div class="card position-relative radius-6">
                <div *ngIf="(chatCount !== (ChatQueriesList.length - 1))">
                  <div class="prompt-user-flexbox">
                    <div class="prompt-user-text">
                      <div *ngIf="!showEdit">
                        <h6 class="m-t-0 m-b-0" [innerHtml]="chatdata.question" id='user_question1'>
                        </h6>
                      </div>
                      <div *ngIf="showEdit">
                        <span class="black-400" contenteditable="true" (input)="onSpanInput($event)"
                          [innerHtml]="chatdata.question"></span>
                      </div>
                    </div>
                  </div>
                  <!-- /* istanbul ignore next */ -->
                  <div class="card pull-left p-t-8 p-l-0 p-r-0 fullwidth chat-message-not-last-sq class1">
                    <div class="response-info-total class1">
                      <div class="response-info-icon class1 m-t-4">
                        <img src="../../assets/images/chatbot-icon.svg" alt="Freya">
                      </div>
                      <div class="response-info-text">
                        <!-- Tab Navigation -->
                        <div class="response-tabs">
                          <!-- <div class="tab-nav">
                            <div class="tab-item active" data-tab="response" (click)="switchTab('response', $event)">
                              <i class="icon-chat" *ngIf="!responseLoadingStates[chatCount]"></i>
                              <div class="response-loader" *ngIf="responseLoadingStates[chatCount]">
                                <div class="spinner"></div>
                              </div>
                              <span>Response</span>
                            </div>
                            <div class="tab-item" *ngIf="(chatdata.newsAndUpdates || newsLoadingStates[chatCount]) && isNewsAndFeedsEnabled" data-tab="news" (click)="switchTab('news', $event)">
                              <img class="icon-megaphone" src="../../../assets/images/megaphone-icon.png" *ngIf="!newsLoadingStates[chatCount]" alt="Megaphone Icon">
                              <div class="news-loader" *ngIf="newsLoadingStates[chatCount]">
                                <div class="spinner"></div>
                              </div>
                              <span>News & Updates ({{ chatdata.newsAndUpdates?.length || 0 }})</span>
                            </div>
                          </div> -->
                          
                          <!-- Response Tab Content -->
                          <div class="tab-content active" id="response-tab">
                            <div class="row m-b-20">
                              <div class="col-12 response-container" >
                                <div class="markdown-answer" *ngIf="chatdata.answer">
                                  <div class="table-scroll-wrapper">
                                    <div class="m-t-0 m-b-10 markdown-content" [innerHTML]="chatdata.answer | sanitizeMarkdown"></div>

                                  </div>
                                </div>
                                <div class="markdown-answer" *ngIf="chatdata.image_visualization">
                                  <div class="table-scroll-wrapper">
                                    <div  class="m-t-0 m-b-10 markdown-content" [innerHTML]="chatdata.image_visualization | sanitizeMarkdown"></div>
                                  </div>
                                </div>
                                <!-- Chart Visualization -->
                                <div *ngIf="chatdata.visualizationData && chatdata.visualizationData.length > 0" class="visualization-section">
                                  <div class="charts-container" 
                                       [ngClass]="{
                                         'single-chart': chatdata.visualizationData.length === 1,
                                         'two-charts': chatdata.visualizationData.length === 2,
                                         'multiple-charts': chatdata.visualizationData.length > 2
                                       }">
                                    <div class="chart-item" 
                                         *ngFor="let chart of chatdata.visualizationData; let i = index"
                                         [ngClass]="{
                                           'chart-single': chatdata.visualizationData.length === 1,
                                           'chart-two': chatdata.visualizationData.length === 2,
                                           'chart-multiple': chatdata.visualizationData.length > 2
                                         }">
                                      <app-chart 
                                        [chartData]="chart" 
                                        [isSmall]="chatdata.visualizationData.length > 1">
                                      </app-chart>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <app-retrieval-mode-history-notice
                              *ngIf="selected_module_name === 'view_access_to_regulations'"
                              [retrievalMode]="chatdata.retrieval_mode">
                            </app-retrieval-mode-history-notice>
                            <div
                              *ngIf="showSources && isMetadataNotEmpty(chatdata.metadata) && (selected_module_name === 'view_access_to_regulations' || selected_module_name === 'view_access_to_rtq')">
                              <app-chatbot-metadata [chatdata]="chatdata" [configdata]="configdata" [tenantId]="tenantID"
                                [isDocChat]="isDocChat" [selected_module_name]="selected_module_name"
                                (closeHistory)="DisableChatHistory()" (DisplaySourcePanel)="DisplaySourcePanel($event)">
                              </app-chatbot-metadata>
                            </div>
                            <div
                              *ngIf="showSources && isMetadataNotEmpty(chatdata.metadata) && !note && (selected_module_name == 'view_access_to_racsstandard' || selected_module_name == 'view_access_to_freya_racs_probiotics_data' || selected_module_name == 'view_access_to_freya_racs_claims_data')">
                              <app-racs-metadata [chatdata]="chatdata" [configdata]="configdata"></app-racs-metadata>
                            </div>
                            <div *ngIf="isOptionsEnable && chatdata.modified_date" class="timestamp">
                              <img src="./assets/images/icon-clock.svg" alt="Timestamp" title="{{'TIMESTAMP_TOOLTIP' | translate}}"/>
                              <small>{{ chatdata.modified_date }}</small>
                            </div>

                            <div class="row response-icons m-t-16" *ngIf="isOptionsEnable">
                              <div class="col-12 response-icons-container">
                                <button [attr.data-tooltip]="'LIKE_BUTTON_TOOLTIP' | translate"
                                  [attr.aria-label]="'LIKE_BUTTON_TOOLTIP' | translate" [ngClass]="{'icon-selected': chatdata.LikeClassAdded}"
                                  (click)="LikeDisLike(chatdata,chatdata.pk_chathistoryid, chatdata.LikeClassAdded)"
                                  type="button" class="btn t-bottom t-no-arrow" id='like_button'>
                                  <i class="icon-thumbs-up"></i>
                                </button>
                                <button [attr.data-tooltip]="'UNLIKE_BUTTON_TOOLTIP' | translate"
                                  [attr.aria-label]="'UNLIKE_BUTTON_TOOLTIP' | translate" [ngClass]="{'icon-selected': chatdata.disLikeClassAdded}"
                                  (click)="DisLikeclick(chatdata,chatdata.pk_chathistoryid, chatdata.disLikeClassAdded)"
                                  type="button" class="btn" id='dislike_button'>
                                  <i class="icon-thumbs-down"></i>
                                </button>
                                <app-audio-copy #audioCopy [chatdata]="chatdata"
                                  [renderedAnswerHtml]="chatdata.answer | sanitizeMarkdown"
                                  [ChatQueriesList]="ChatQueriesList"
                                  (ChatQueriesListEmit)="onChatQueriesListEmit($event)">
                                </app-audio-copy>
                                <app-share-conversation 
                                [chatdata]="chatdata"
                                [tenantId]="tenantID"
                                (showSharePopup)="onShowSharePopup($event)"
                                (hideSharePopup)="onHideSharePopup()"
                                (universalLoading)="universalLoader($event)">
                                </app-share-conversation>
                              </div>
                            </div>
                            <app-feedback-section [chatdata]="chatdata" [configdata]="configdata"
                              (onClear)="clearCheckboxes($event)"
                              (onSubmit)="Dislikesubmit($event, $event.pk_chathistoryid, false)">
                            </app-feedback-section>
                            <div class="row"
                              *ngIf="(chatdata.disLikeClassAdded && !chatdata.SubmitFeedback) || chatdata.LikeClassAdded">
                              <div class="feed-back-section" id='greeting_message'>
                                <p class="m-0">{{'EVOLVE_TOASTER_MESSAGE' | translate}}</p>
                              </div>
                            </div>
                            <div class="row" *ngIf="chatdata.followUpQuestions && chatdata.followUpQuestions[0] && chatdata.followUpQuestions[0].length > 0">
                              <div class="col-12 followup-questions-total">
                                <h6 class="font-subheading1 m-t-20 m-b-15">{{'RELATED_QUESTIONS_TITLE_TEXT' | translate}}</h6>
                                <div class="followup-questions-list"
                                  *ngFor="let fq of chatdata.followUpQuestions;let i = index">
                                  <div *ngFor="let item of fq;">
                                    <a href="javascript: void(0)"[class.disabled]="isProcessing || loaderShow"
                                     (click)="FollowUpQuestionClick(item)"
                                      [id]='"follow_up_question_link" + i'
                                      >{{item}}</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <!-- News & Updates Tab Content -->
                          <div class="tab-content" id="news-tab" *ngIf="isNewsAndFeedsEnabled">
                            <app-news-updates 
                              [newsItems]="chatdata.newsAndUpdates || []"
                              [news_feeds_id]="chatdata.news_feeds_id || null"
                              [isresponseLoading]="responseLoadingStates[chatCount] || false"
                              [isNewsLoading]="newsLoadingStates[chatCount] || false"
                              [tenantId]="tenantID"
                              [domainId]="DomainID"
                              [userId]="UserID"
                              [errorMessage]="newsErrorStates[chatCount] || ''"
                              [isWebsocketCompleteAndDataSaved]="websocketCompleteAndDataSaved[chatCount] || false"
                              (linkClick)="onNewsLinkClick($event)"
                              [newsAndUpdatesnodata]="shouldShowNoNewsData(chatdata)">
                            </app-news-updates>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="(chatCount !== (ChatQueriesList.length - 1))">
                  </div>
                </div>
              </div>
            </div>

            <div class="lastDiv" *ngFor="let chatdata of ChatQueriesList;  let chatCount = index">

              <div *ngIf="(chatCount === (ChatQueriesList.length - 1))">
                <!-- File Pills Above Question Card -->
                <div class="message-file-pills" *ngIf="isFileUploadEnabled && chatdata.attachedFiles && chatdata.attachedFiles.length > 0">
                  <div class="message-file-pill" *ngFor="let file of chatdata.attachedFiles" 
                       (click)="previewFile(file)"
                       (keydown.enter)="previewFile(file)"
                       tabindex="0"
                       role="button"
                       [attr.aria-label]="'Preview file ' + file.name"
                       [title]="file.name + ' - ' + formatFileSize(file.size)">
                    <div class="message-file-pill-icon">
                      <img src="./assets/icons/pdf-icon.svg" alt="PDF" *ngIf="file.type === 'application/pdf'" />
                      <img src="./assets/icons/word-icon.svg" alt="Word" *ngIf="file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" />
                      <img src="./assets/icons/text.svg" alt="Text" *ngIf="file.type === 'text/plain'" />
                    </div>
                    <span class="message-file-pill-name">{{ file.name }}</span>
                  </div>
                </div>
                <div class="card position-relative radius-6">
                  <div class="prompt-user-flexbox">
                    <div class="prompt-user-text">
                      <div *ngIf="!showEdit">
                        <h6 class="font-subheading1 m-t-0 m-b-0 text-line20" [innerHtml]="chatdata.question"
                          id='relative_question_div'></h6>
                      </div>
                      <div *ngIf="showEdit">
                        <span class="black-400" contenteditable="false" (input)="onSpanInput($event)"
                          [innerHtml]="chatdata.question">
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- /* istanbul ignore next */ -->
                  <div class="card pull-left p-t-8 p-l-0 p-r-0 fullwidth chat-message-not-last-sq class2">
                    <div class="response-info-total class2">
                      <div class="response-info-icon m-t-4">
                        <img src="../../assets/images/chatbot-icon.svg" alt="Freya">
                      </div>
                      <div class="response-info-text">
                        <!-- Tab Navigation -->
                        <div class="response-tabs">
                          <!-- <div class="tab-nav">
                            <div class="tab-item active" data-tab="response" (click)="switchTab('response', $event)">
                              <i class="icon-chat" *ngIf="!responseLoadingStates[chatCount]"></i>
                              <div class="response-loader" *ngIf="responseLoadingStates[chatCount]">
                                <div class="spinner"></div>
                              </div>
                              <span>Response</span>
                            </div>
                            <div class="tab-item" *ngIf="(chatdata.newsAndUpdates || newsLoadingStates[chatCount]) && isNewsAndFeedsEnabled" data-tab="news" (click)="switchTab('news', $event)">
                              <img class="icon-megaphone" src="../../../assets/images/megaphone-icon.png" *ngIf="!newsLoadingStates[chatCount]" alt="Megaphone Icon">
                              <div class="news-loader" *ngIf="newsLoadingStates[chatCount]">
                                <div class="spinner"></div>
                              </div>
                              <span>News & Updates ({{ chatdata.newsAndUpdates?.length || 0 }})</span>
                            </div>
                          </div> -->
                          
                          <!-- Response Tab Content -->
                          <div class="tab-content active" id="response-tab">
                            <div class="row m-b-20">
                              <div class="col-12 response-container">
                                <div class="markdown-answer" *ngIf="chatdata.answer">
                                  <div class="table-scroll-wrapper">
                                    <div class="m-t-0 m-b-10 markdown-content"  [innerHTML]="chatdata.answer | sanitizeMarkdown"></div>
                                  </div>
                                </div>
                                <div class="markdown-answer" *ngIf="chatdata.image_visualization">
                                  <div class="table-scroll-wrapper">
                                    <div class="m-t-0 m-b-10 markdown-content" [innerHTML]="chatdata.image_visualization | sanitizeMarkdown"></div>
                                  </div>
                                </div>
                                <!-- Chart Visualization -->
                                <div *ngIf="chatdata.visualizationData && chatdata.visualizationData.length > 0" class="visualization-section">
                                  <div class="charts-container" 
                                      [ngClass]="{
                                        'single-chart': chatdata.visualizationData.length === 1,
                                        'two-charts': chatdata.visualizationData.length === 2,
                                        'multiple-charts': chatdata.visualizationData.length > 2
                                      }">
                                    <div class="chart-item" 
                                        *ngFor="let chart of chatdata.visualizationData; let i = index"
                                        [ngClass]="{
                                          'chart-single': chatdata.visualizationData.length === 1,
                                          'chart-two': chatdata.visualizationData.length === 2,
                                          'chart-multiple': chatdata.visualizationData.length > 2
                                        }">
                                      <app-chart 
                                        [chartData]="chart" 
                                        [isSmall]="chatdata.visualizationData.length > 1">
                                      </app-chart>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>                      

                            <app-retrieval-mode-history-notice
                              *ngIf="selected_module_name === 'view_access_to_regulations' && chatdata.pk_chathistoryid"
                              [retrievalMode]="chatdata.retrieval_mode">
                            </app-retrieval-mode-history-notice>
                            <div
                              *ngIf="showSources && isMetadataNotEmpty(chatdata.metadata) && (selected_module_name === 'view_access_to_regulations' || selected_module_name === 'view_access_to_rtq')">
                              <app-chatbot-metadata [chatdata]="chatdata" [configdata]="configdata" [tenantId]="tenantID"
                                [isloader]="IsLoader" [isResponseStreaming]="IsResponseStreaming" [isDocChat]="isDocChat" [selected_module_name]="selected_module_name"
                                (closeHistory)="DisableChatHistory()" (DisplaySourcePanel)="DisplaySourcePanel($event)">
                              </app-chatbot-metadata>
                            </div>
                            <div
                              *ngIf="showSources && isMetadataNotEmpty(chatdata.metadata) && (selected_module_name == 'view_access_to_racsstandard' || selected_module_name == 'view_access_to_freya_racs_probiotics_data' || selected_module_name == 'view_access_to_freya_racs_claims_data')">
                              <app-racs-metadata [chatdata]="chatdata" [configdata]="configdata"></app-racs-metadata>
                            </div>
                            <div
                              *ngIf="showSources && isMetadataNotEmpty(chatdata.metadata) && selected_module_name == 'access_to_iyc_data'">
                              <app-iyc-metadata [chatdata]="chatdata" [configdata]="configdata"></app-iyc-metadata>
                            </div>
                            <app-engaging-loader *ngIf="loaderShow" [showStreamingDots]="!showEngagingLoader && loaderShow" [module]="selectedVectorDbDataset?.name?.toLowerCase() || 'regulations'"></app-engaging-loader>

                            <div *ngIf="isOptionsEnable && chatdata.modified_date" class="timestamp">
                              <img src="./assets/images/icon-clock.svg" alt="Timestamp" title="{{'TIMESTAMP_TOOLTIP' | translate}}" />
                              <small>{{ chatdata.modified_date}}</small>
                            </div>

                            <div class="note-helptext m-b-20" *ngIf="note && configdata.isNoteInfo">
                              <div class="row">
                                <div class="col-1 display-flex">
                                  <img src="./assets/images/info.svg" alt="Note" title="Note" />
                                </div>
                                <div class="col-11" [innerHtml]="configdata.NoteInfo">
                                </div>
                              </div>
                            </div>
                            <div class="row response-icons m-t-16" *ngIf="isOptionsEnable">
                              <div class="col-12 response-icons-container">
                                <button [attr.data-tooltip]="'LIKE_BUTTON_TOOLTIP' | translate"
                                  [attr.aria-label]="'LIKE_BUTTON_TOOLTIP' | translate" [ngClass]="{'icon-selected': chatdata.LikeClassAdded}"
                                  (click)="LikeDisLike(chatdata,chatdata.pk_chathistoryid,chatdata.LikeClassAdded)"
                                  type="button" class="btn t-bottom t-no-arrow" id='like_button'>
                                  <i class="icon-thumbs-up"></i>
                                </button>
                                <button [attr.data-tooltip]="'UNLIKE_BUTTON_TOOLTIP' | translate"
                                  [attr.aria-label]="'UNLIKE_BUTTON_TOOLTIP' | translate" [ngClass]="{'icon-selected': chatdata.disLikeClassAdded}"
                                  (click)="DisLikeclick(chatdata,chatdata.pk_chathistoryid, chatdata.disLikeClassAdded)"
                                  type="button" class="btn t-bottom t-no-arrow" id='dislike_button'>
                                  <i class="icon-thumbs-down"></i>
                                </button>
                                <app-audio-copy #audioCopy [chatdata]="chatdata"
                                  [renderedAnswerHtml]="chatdata.answer | sanitizeMarkdown"
                                  [ChatQueriesList]="ChatQueriesList"
                                  (ChatQueriesListEmit)="onChatQueriesListEmit($event)">
                                </app-audio-copy>
                                <app-share-conversation
                                [chatdata]="chatdata"
                                [tenantId]="tenantID"
                                (universalLoading)="universalLoader($event)"
                                (showSharePopup)="onShowSharePopup($event)"
                                (hideSharePopup)="onHideSharePopup()">
                                </app-share-conversation>
                                <div class="dropdown" *ngIf="!note" id='options_dropdown'>
                                  <button class="dropdown-toggle t-bottom t-no-arrow" type="text" [attr.data-tooltip]="'OPTIONS_TOOLTIP' | translate"
                                  [attr.aria-label]="'OPTIONS_TOOLTIP' | translate"></button>
                                  <div class="dropdown-text">
                                    <img src="../../../assets/icons/more-menu-icon-v2.svg" alt="Preferences Icon" class = "icon-more" />
                                  </div>
                                  <ul class="dropdown-content">
                                    <li>
                                      <a href="javascript: void(0)" id='regenerate_response_button'
                                        (click)="RegenerateActions(chatdata.question,'Regenerate')"
                                        [ngClass]="{'disabled': isProcessing}">
                                        <img src="../../../assets/icons/icon-regenerate.svg" alt="Regenerate" width="16" height="16" />
                                        {{'REGENERATE_RESPONSE_BUTTON_TEXT' | translate}}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="javascript: void(0)" id='make_response_crisp_button'
                                        (click)="RegenerateActions(chatdata.question,'Shorter')"
                                        [ngClass]="{'disabled': isProcessing}">
                                        <img src="../../../assets/icons/icon-short-response.svg" alt="Make Crisp" width="16" height="16" />
                                        {{'RESPONSE_CRISP_BUTTON_TEXT' | translate}}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="javascript: void(0)" id='give_detailed_response_button'
                                        (click)="RegenerateActions(chatdata.question,'Longer')"
                                        [ngClass]="{'disabled': isProcessing}">
                                        <img src="../../../assets/icons/icon-detailed-response.svg" alt="Detailed Response" width="16"
                                          height="16" />
                                          {{'DETAILED_RESPONSE_BUTTON_TEXT' | translate}}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                               
                              </div>
                            </div>

                            <app-feedback-section [chatdata]="chatdata" [configdata]="configdata"
                              (onClear)="clearCheckboxes($event)"
                              (onSubmit)="Dislikesubmit($event, $event.pk_chathistoryid, false)">
                            </app-feedback-section>
                            <div class="row"
                              *ngIf="(chatdata.disLikeClassAdded && !chatdata.SubmitFeedback) || chatdata.LikeClassAdded">
                              <div class="feed-back-section" id='greeting_message'>
                                <p class="m-0">{{'EVOLVE_TOASTER_MESSAGE' | translate}}</p>
                              </div>
                            </div>
                            <div class="row" *ngIf="chatdata.followUpQuestions && chatdata.followUpQuestions[0] && chatdata.followUpQuestions[0].length > 0">
                              <div class="col-12 followup-questions-total">
                              <h6 class="font-subheading1 m-t-20 m-b-15">{{'FOLLOWUP_QUESTIONS_TITLE_TEXT' | translate}}</h6>
                                <div class="followup-questions-list"
                                  *ngFor="let fq of chatdata.followUpQuestions;let i = index">
                                  <div *ngFor="let item of fq;">
                                    <a href="javascript: void(0)" (click)="FollowUpQuestionClick(item)"
                                    [class.disabled]="isProcessing || loaderShow"
                                      [id]='"follow_up_question_link" + i'
                                      >{{item}}</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <!-- News & Updates Tab Content -->
                          <div class="tab-content" id="news-tab" *ngIf="isNewsAndFeedsEnabled">
                            <app-news-updates 
                              [newsItems]="chatdata.newsAndUpdates || []"
                              [news_feeds_id]="chatdata.news_feeds_id || null"
                              [isresponseLoading]="responseLoadingStates[chatCount] || false"
                              [isNewsLoading]="newsLoadingStates[chatCount] || false"
                              [errorMessage]="newsErrorStates[chatCount] || ''"
                              [tenantId]="tenantID"
                              [domainId]="DomainID"
                              [userId]="UserID"
                              [isWebsocketCompleteAndDataSaved]="websocketCompleteAndDataSaved[chatCount] || false"
                              (linkClick)="onNewsLinkClick($event)"
                              [newsAndUpdatesnodata]="shouldShowNoNewsData(chatdata)">
                            </app-news-updates>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <!-- Scroll target element -->
          <div id="scrolltobottom"></div>
        </div>

        <!-- Floating Help Button -->
        <div class="help-fab" *ngIf="firstTimeLoginDetails.wizard_completion_status === 'completed'"
         (click)="toggleHelpMenu()"
         [ngClass]="{
           'with-source-panel': isSourcePanelVisible || isFilePreviewVisible
         }">
          ?
        </div>

        <!-- Help Menu Popup -->
        <div class="help-menu-popup" *ngIf="showHelpMenu"
         [ngClass]="{
           'with-source-panel': isSourcePanelVisible || isFilePreviewVisible
         }">
          <div class="help-menu-item" (click)="openIntroWizard()" (keydown.enter)="openIntroWizard()" tabindex="0" role="button">
            <span class="help-menu-icon">?</span>
            {{'ASK_FREYA_POPUP_TEXT' | translate}}
          </div>
        </div>

        <div *ngIf="showHelp" class="intro-wiz-container">
          <app-intro-wizard (close)="toggleHelp()"></app-intro-wizard>
        </div>

        <div class="intro-slides" *ngIf="showIntroSlides()">
          <app-intro-slides [userName]="userFName" [vectorDbDatasets]="vectorDbDatasets"
            [tenantId]="tenantID"
            [domainId]="DomainID"
            [isIntroWizardEnabled]="firstTimeLoginDetails.introduction_wizard_enabled"
            [introWizardStatus]="firstTimeLoginDetails.wizard_completion_status"
            [isTourEnabled]="firstTimeLoginDetails.tour_functionality_enabled"
            [tourStatus]="firstTimeLoginDetails.tour_completion_status"
            (selectedDatasetChange)="selectedVectorDbDataset = $event" (favouriteDataset)="favouriteDataset = $event"
            (resizeDropDownWidth)="resizeDropdownWidth()"
            (showIntroSlides)="firstTimeLoginDetails.wizard_completion_status = $event">
          </app-intro-slides>
        </div>

        <div class="prompt-overlay" *ngIf="DisplayPromptLibrary" (click)="DisplayPromptLibrary = false">
          <div class="prompt-popup-wrapper" (click)="$event.stopPropagation()">
            <app-prompt-library [toggledDbDataset]="selectedVectorDbDataset"
              [selectedVectorDbDataset]="selectedVectorDbDataset" [vectorDbDatasets]="vectorDbDatasets"
              [loaderShow]="loaderShow" [IsResponseStreaming]="isProcessing" (uploadQuestionSelected)="txtChat = $event"
              (clickNewChatFunc)="ClickNewChat($event)" (sendRequestEmitted)="SendRequest($event)"
              (newSelectedDataset)="onNewSelectedDataset($event)" (close)="DisplayPromptLibrary = false"
              (scrollBottom)="scrollToBottomSmooth()"
              [domainName]="moduleName"
              [tenantId]="tenantID"
              [userId]="UserID">
            </app-prompt-library>
          </div>
        </div>

        <div class="domain-switch-container"
            [ngClass]="{'on-chat-history-open': ShowChatHistory}"
            *ngIf="isDomainManagementEnabled">
          <app-domain-switch
            #domainSwitchComponent
            [textareaElement]="textareaElement"
            [allDomainNames]="allDomainNamesList.length > 0 ? allDomainNamesList : []"
            [isNewChatbotEnabled]="true"
            (suggestionSelected)="onSuggestionSelected($event)"
            (domainInserted)="onDomainInserted()">
          </app-domain-switch>
        </div>
        <div class="input-with-uploads" [ngClass] ="{
          'new-session': !IsNewChat,
          'has-files': isFileUploadEnabled && fileUploadState.ui.showFileCards,
          'has-files-newchat': isFileUploadEnabled && fileUploadState.ui.showFileCards&& IsNewChat

        }">
          <div class="prompt-section landing-screen position-relative" [ngClass]="{
            'prompt-section': !isInAgentMode,
            'landing-screen': !isInAgentMode,
            'agent-prompt-container': isInAgentMode,
            'fist-time-formprompt': IsFirstTime,
            'new-session': !IsNewChat,
           'prompt-section--narrow': ShowChatHistory && ConversationHistoryCount >= 0 && !isInAgentMode,
            'collapsed': ShowChatHistory && !IsNewChat,
            'has-files': isFileUploadEnabled && fileUploadState.ui.showFileCards && fileUploadState.uploadedFiles.length > 0,
            'shift-up': isFileUploadEnabled && isMyUploadedFiles && IsNewChat,
            }"
            (dragover)="isFileUploadEnabled ? onDragOver($event) : null"
            (dragenter)="isFileUploadEnabled ? onDragEnter($event) : null"
            (dragleave)="isFileUploadEnabled ? onDragLeave($event) : null"
            (drop)="isFileUploadEnabled ? onDrop($event) : null">
            <!-- Scroll to Bottom Arrow -->
            <div class="scroll-to-bottom-arrow" *ngIf="showScrollToBottomArrow" (click)="onScrollToBottomArrowClick()">
              <button class="scroll-arrow-btn" type="button">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 5V19M12 19L6 13M12 19L18 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            
            <!-- File Validation Errors - At Top -->
            <div class="file-validation-errors-top show" *ngIf="isFileUploadEnabled && fileUploadState.validation.showErrors && fileUploadState.validation.errors.length > 0">
              <div class="validation-error-header">
                <i class="fa-solid fa-exclamation-triangle"></i>
                <span>{{ fileUploadState.validation.errors.join('; ') }}</span>
                <button class="dismiss-errors-btn" (click)="dismissValidationErrors()">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
            </div>

            <!-- Drag and Drop Overlay -->
            <div class="drag-drop-overlay" 
                *ngIf="isFileUploadEnabled && fileUploadState.ui.isDragOver" 
                (click)="onFileInputClick()">
              <div class="drag-drop-content">
                <div class="drag-drop-icon">
                  <i class="fa-solid fa-paperclip"></i>
                </div>
                <div class="drag-drop-text">
                  <span>Drop Files here</span>
                </div>
              </div>
            </div>
            <!-- File Pills Display Inside Prompt Section -->
            <div class="file-pills-container" *ngIf="isFileUploadEnabled && ((fileUploadState.ui.showFileCards && fileUploadState.uploadedFiles.length > 0) || getUploadingFileNames().length > 0)">
              
              <!-- Uploaded Files -->
              <div class="file-pill" *ngFor="let file of fileUploadState.uploadedFiles; let i = index">
                <div class="file-pill-icon">
                <img src="./assets/icons/pdf-icon.svg" alt="PDF" *ngIf="file.type === 'application/pdf'" />
                <img src="./assets/icons/word-icon.svg" alt="Word" *ngIf="file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" />
                  <img src="./assets/icons/text.svg" alt="Text" *ngIf="file.type === 'text/plain'" />
                </div>
                <span class="file-pill-name">{{ file.name }}</span>
                <div class="file-pill-divider"></div>
                <button class="file-pill-remove" (click)="removeFile(i)">
                <img src="./assets/icons/close-thin.svg" alt="Remove" class="close-icon" />
                </button>
                <!-- Custom Tooltip -->
                <div class="file-tooltip">
                  {{ file.name }} - {{ formatFileSize(file.size) }}
                </div>
              </div>

              <!-- Files Being Uploaded -->
              <div class="file-pill uploading" *ngFor="let tracker of getUploadingFiles()" 
                  [ngClass]="{'success': tracker.status === 'success', 'error': tracker.status === 'error'}">
                <div class="file-pill-icon-wrapper">
                  <!-- Circular Progress Spinner around icon -->
                  <svg class="file-upload-spinner" 
                       *ngIf="tracker.status === 'uploading' || tracker.status === 'validating' || tracker.status === 'validating-pages'"
                       viewBox="0 0 50 50">
                    <circle class="spinner-track" cx="25" cy="25" r="20"></circle>
                    <circle class="spinner-progress" 
                            cx="25" cy="25" r="20"
                            [style.stroke-dashoffset]="125.6 - (125.6 * (tracker.progress || 0))"></circle>
                  </svg>
                  
                  <div class="file-pill-icon">
                    <img src="./assets/icons/pdf-icon.svg" alt="PDF" *ngIf="tracker.file.name.toLowerCase().endsWith('.pdf')" />
                    <img src="./assets/icons/word-icon.svg" alt="Word" *ngIf="tracker.file.name.toLowerCase().endsWith('.docx')" />
                    <img src="./assets/icons/text.svg" alt="Text" *ngIf="tracker.file.name.toLowerCase().endsWith('.txt')" />
                    <i class="fa-solid fa-check" *ngIf="tracker.status === 'success'"></i>
                    <i class="fa-solid fa-exclamation-triangle" *ngIf="tracker.status === 'error'"></i>
                  </div>
                </div>
                <span class="file-pill-name">{{ tracker.file.name }}</span>
                <div class="file-pill-divider"></div>
                <button class="file-pill-close" (click)="cancelFileUpload(tracker.file.name)" *ngIf="tracker.status !== 'success'">
                <img src="./assets/icons/close-thin.svg" alt="Remove" class="close-icon" />

                </button>
                
                <!-- Custom Tooltip -->
                <div class="file-tooltip">
                  {{ tracker.file.name }} - {{ formatFileSize(tracker.file.size) }}
                </div>
              </div>
            </div>
          <!-- ✅ REGULAR: Full Input (with all features) (shown when not agent mode) -->
          <div *ngIf="!isInAgentMode">
            <div class="form-input flex-col" [ngClass]="{'has-file-pills': isFileUploadEnabled && fileUploadState.ui.showFileCards && fileUploadState.uploadedFiles.length > 0}">
              <div
                #autoResizeTextarea
                class="form-prompt"
                (keydown)="onEnterPress($event)"
                [(ngModel)]="txtChat"
                (input)="onTextInput()"
                [attr.data-placeholder]="'TEXTAREA_PLACEHOLDER_TEXT' | translate"
                id="text_area"
                contenteditable="true">
              </div>
            </div>
            <div class="prompt-box-bottom p-b-8" [ngClass]="{'prompt-no-ddl': vectorDbDatasets.length == 1}">
              <!-- Move the prompt-library button here -->
              <div class="prompt-library-container">
                <button class="prompt-library m-t-6 m-l-4 text-nowrap p-l-16 btn-icon-flex hover-effect-text t-bottom t-no-arrow"
                (click)="OnPromptLibrary()"> <span class="prompt-library-icon-wrap t-bottom t-no-arrow" [attr.data-tooltip]="'TEXTAREA_PROMPT_LIBRARY_BUTTON' | translate"
                  [attr.aria-label]="'TEXTAREA_PROMPT_LIBRARY_BUTTON' | translate"><img src="../../assets/images/newchat/icon-prompt-library.svg"
                  class="icon-sm p-t-2" alt="prompt library"></span> {{'TEXTAREA_PROMPT_LIBRARY_BUTTON' | translate}}</button>
                </div>
              <!-- Prompt right actions here -->
              <div class="prompt-box-bottom-right">
                <div class="show-source">
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="showSources" (click)="onShowSource()" />
                  </label>
                </div>

                <!-- File Upload Popup Button -->
                <div class="file-upload-popup-container pull-left" *ngIf="isFileUploadEnabled">
                  <button class="file-upload-popup-button t-bottom t-no-arrow" (click)="toggleFileUploadPopup()" 
                          [ngClass]="{'active': fileUploadState.ui.isPopupOpen}"
                          [attr.data-tooltip]="'Attach Files'"
                          [attr.aria-label]="'Attach Files'">
                    <i class="fa-solid fa-paperclip"></i>
                  </button>
                  
                  <!-- File Upload Popup -->
                  <div class="upload-popover " *ngIf="fileUploadState.ui.isPopupOpen" 
                  [ngClass]="{'show': fileUploadState.ui.isPopupOpen, 'above': !IsNewChat}">
                    <div class="file-upload-option" (click)="onFileUploadOptionClick('local-files')" (keydown.enter)="onFileUploadOptionClick('local-files')" tabindex="0" role="button">
                      <div class="option-icon">
                        <img src="../../assets/icons/upload-files.svg" alt="Upload Files Icon" class="upload-files-icon">
                      </div>
                      <span class="option-text">Upload Files</span>
                      <div class="option-info">
                        <i class="fa-solid fa-info-circle"></i>
                      </div>
                    </div>
                    
                    <div class="file-upload-option" (click)="onFileUploadOptionClick('workspace')" (keydown.enter)="onFileUploadOptionClick('workspace')" tabindex="0" role="button">
                      <div class="option-icon workspace-icon">
                        <img src="../../assets/icons/work-content.svg" alt="Workspace Icon" class="workspace-type-icon">
                      </div>
                      <span class="option-text">My Files</span>
                    </div>
                  </div>
                </div>

                <div class=" custom-dropdown " *ngIf="vectorDbDatasets.length > 0"
                
            >  
            <!-- custom-dropdown -->
              <div class="dropdown-selected" (click)="toggleDropdown()" (keydown.enter)="toggleDropdown()" tabindex="0" role="button">
                <span class="dropdown-text">{{ getSelectedOptionLabel() }}</span>
                <span class="dropdown-arrow">
                    <i class="fa-solid fa-chevron-down" [ngClass]="{'rotate': isDropdownOpen}"></i>
                </span>
              </div>
              <div class="dropdown-menu" *ngIf="isDropdownOpen">
                <div class="dropdown-option" *ngFor="let option of vectorDbDatasets; let i = index"
                      (click)="selectOption(option)"
                      [id]="'dropdown_options' + i">
                      {{ (option.name | translate) === (favouriteDataset | translate) ? (option.name | translate) + ' &#11088;' : (option.name | translate) }}
                </div>
              </div>
              </div>



                <app-retrieval-mode-toggle *ngIf="showRetrievalModeToggle"></app-retrieval-mode-toggle>

                <!-- Voice Input Mic -->
                <div class="voice-input-container"
                  [ngClass]="{ 'visible': micActive || !txtChat, 'hidden': !micActive && txtChat }">
                  <app-voice-input 
                  (speechText)="onMicSpeechUpdate($event)" 
                  (micStatus)="onMicStatusUpdate($event)"
                  (speechError)="onMicSpeechError($event)"></app-voice-input>
                </div>
            


                <!-- Send Button -->
                <button class="btn-chat-send"
                        (click)="!loaderShow && txtChat ? SendRequest(false) : null"
                        [disabled]="(loaderShow || !txtChat?.trim())"
                        [ngClass]="{ 'visible': !micActive && txtChat, 
                        'hidden': micActive || !txtChat}">
                  <i class="fa-solid fa-arrow-up"></i>
                </button>


              </div>
            </div>
          </div>
          </div>
          <!-- ✅ END Regular Input -->
          <div *ngIf="isFileUploadEnabled && isMyUploadedFiles"
              class="prompt-section landing-screen my-uploaded-files" 
              [ngClass] = "{
                            'has-files': fileUploadState.ui.showFileCards && fileUploadState.uploadedFiles.length > 0,
                            'has-files-newchat': fileUploadState.ui.showFileCards && fileUploadState.uploadedFiles.length > 0 && IsNewChat
                           }"
              #myUploadedFilesRef>
            <app-my-files [isLoading]="isMyFilesLoading" (close)="isMyUploadedFiles = false" (uploadLocalFiles)="onFileUploadOptionClick('local-files')" (selectExistingFiles)="onExistingFilesSelected($event)" (deselectExistingFile)="onExistingFileDeselected($event)"></app-my-files>
          </div>
        </div>
        <app-welcome-tour *ngIf="showWelcomeTour()"
        [userFName]="userFName"
        [tenantId]="tenantID"
        [domainId]="DomainID"
        [isIntroWizardEnabled]="firstTimeLoginDetails.introduction_wizard_enabled"
        [introWizardStatus]="firstTimeLoginDetails.wizard_completion_status"
        [isTourEnabled]="firstTimeLoginDetails.tour_functionality_enabled"
        [tourStatus]="firstTimeLoginDetails.tour_completion_status"
        (close)="firstTimeLoginDetails.tour_functionality_enabled = false"
        (emitTourVisible) = "firstTimeLoginDetails.tour_completion_status = $event"></app-welcome-tour>
        <!--Prompt box end here-->
      </div>
      
      <!-- Source Panel Column -->
      <div *ngIf="isSourcePanelVisible" class="source-panel-column">
        <app-source-panel 
          [sourceContext]="currentSourceData"
          [configdata]="configdata"
          [tenantId]="tenantID"
          [domainId]="DomainID"
          (closePanelEvent)="closeSourcePanel()">
        </app-source-panel>
      </div>

      <!-- File Preview Panel Column -->
      <div *ngIf="isFilePreviewVisible" class="file-preview-column">
        <app-file-preview 
          [previewRequest]="currentFilePreviewRequest"
          [isVisible]="isFilePreviewVisible"
          (closePanelEvent)="closeFilePreviewPanel()">
        </app-file-preview>
      </div>
    </div>
    <div *ngIf="!isInAgentMode" class="disclaimer-fixed footer-sticky"
      [ngClass]="{
        'fullwidth-disclaimer': (!ShowChatHistory || ConversationHistoryCount === 0) && !isSourcePanelVisible && !isFilePreviewVisible,
        'with-source-panel': isSourcePanelVisible || isFilePreviewVisible
      }">
      {{'DISCLAIMER_TEXT_FREYA' | translate}}
    </div>
  </div>

  <!-- New Chat While Streaming Confirmation Popup -->
  <div class="popup-backdrop" *ngIf="showNewChatConfirmationPopup" (click)="$event.stopPropagation()">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'NEW_CHAT_STREAMING_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <p>{{'NEW_CHAT_STREAMING_POPUP_CONTENT' | translate}}</p>
      </div>
      <div class="popup-footer">
        <button (click)="confirmNewChatWhileStreaming()" class="button primary">{{'CONFIRM_BUTTON_TEXT' | translate}}</button>
        <button (click)="cancelNewChatWhileStreaming()" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </div>

  <!-- Agent Switch to Chatbot Confirmation Popup -->
  <div class="popup-backdrop" *ngIf="showAgentSwitchConfirmationPopup" (click)="$event.stopPropagation()">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'NEW_CHAT_STREAMING_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <p>{{'CHATBOT_SWITCH_STREAMING_POPUP_CONTENT' | translate}}</p>
      </div>
      <div class="popup-footer">
        <button (click)="confirmAgentSwitchToChatbot()" class="button primary">{{'CONFIRM_BUTTON_TEXT' | translate}}</button>
        <button (click)="cancelAgentSwitchToChatbot()" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </div>

  <!-- Chatbot to Agent Confirmation Popup (when chatbot is streaming) -->
  <div class="popup-backdrop" *ngIf="showChatbotToAgentConfirmationPopup" (click)="$event.stopPropagation()">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'SWITCH_TO_AGENT_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <p>{{'SWITCH_TO_AGENT_POPUP_CONTENT' | translate}}</p>
      </div>
      <div class="popup-footer">
        <button (click)="confirmChatbotToAgentSwitch()" class="button primary">{{'CONFIRM_BUTTON_TEXT' | translate}}</button>
        <button (click)="cancelChatbotToAgentSwitch()" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </div>

  <!-- Save Error Confirmation Popup -->
  <div class="popup-backdrop" *ngIf="showSaveErrorConfirmationPopup" (click)="$event.stopPropagation()">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'ERROR_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <p>{{saveErrorMessage}}</p>
      </div>
      <div class="popup-footer">
        <button (click)="confirmSaveErrorAndRedirect()" class="button primary">{{'OK_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </div>

  <!-- Share Conversation Popup - Global Level -->
  <div class="popup-backdrop" *ngIf="sharePopupData && sharePopupData.share_link" (click)="$event.stopPropagation()">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'SHARE_LINK' | translate}} <button class="close-button" (click)="closeShareConversationPopup() ">
          <img src="../../../assets/icons/close.svg" alt="Close">
        </button></h1>
        
      </div>
      <div class="popup-body">
        <p class="popup-subtitle">{{'SHARE_CONVERSATION_DESCRIPTION' | translate}}</p>
        <div class="form-button">
          <input type="text" [value]="sharePopupData.share_link" readonly class="share-link-input" 
                 style="background-color: #f5f5f5; cursor: default;">
          <button (click)="copyShareConversationLink()" 
                  class="button primary copied"
                  [disabled]="linkCopied">
            <img [src]="linkCopied ? '../../../assets/icons/check.svg': '../../../assets/icons/link.svg'" 
                 alt="Copy"
                 class="copy-button-icon"
                 [class.link-icon]="!linkCopied"
                 [class.check-icon]="linkCopied">
            {{ (linkCopied ? 'COPIED_TITLE_TEXT' : 'COPY_LINK') | translate}}
          </button>
        </div>
      </div>
      <div class="popup-footer">
      </div>
    </div>
  </div>
</main>